var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('div',{staticClass:"container-splash"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":("Logo " + _vm.institutionName)}}),_c('ProgressLinearAnimated')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }